import { render, staticRenderFns } from "./AppWelcomePanel.vue?vue&type=template&id=409d0b67&scoped=true&"
import script from "./AppWelcomePanel.vue?vue&type=script&lang=js&"
export * from "./AppWelcomePanel.vue?vue&type=script&lang=js&"
import style0 from "./AppWelcomePanel.vue?vue&type=style&index=0&id=409d0b67&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d0b67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
